import { StepOneController } from './layer/controllerLayer';
export function StepOne() {
    const stepController = new StepOneController();
}
